// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__nYRIG","header":"PatientQuestionnaire_header__23qz9","info":"PatientQuestionnaire_info__3iKfX"};